
import React from 'react';
import { Line } from 'react-chartjs-2';

export default class FFTLineChart extends React.Component {
    chartOption
    chartRef

    constructor(props) {
        super(props)

        const maxHz = props.maxHz || 50
        const height = props.height || 200

        // 0-50Hz 라벨 생성
        const labels = Array.from({ length: maxHz + 1 }, (_, i) => i)

        this.state = {
            maxHz,
            height,
            chartData: {
                labels,
                datasets: [
                    {
                        label: 'CH1 (Left)',
                        fill: false,
                        borderColor: '#FF6B6B',
                        backgroundColor: 'rgba(255, 107, 107, 0.1)',
                        borderWidth: 1.5,
                        pointRadius: 0,
                        pointHoverRadius: 3,
                        data: new Array(maxHz + 1).fill(0)
                    },
                    {
                        label: 'CH2 (Right)',
                        fill: false,
                        borderColor: '#4ECDC4',
                        backgroundColor: 'rgba(78, 205, 196, 0.1)',
                        borderWidth: 1.5,
                        pointRadius: 0,
                        pointHoverRadius: 3,
                        data: new Array(maxHz + 1).fill(0)
                    }
                ]
            }
        }
    }

    /**
     * FFT 데이터 업데이트
     * @param {Array} ch1FFT - 채널1 FFT 데이터
     * @param {Array} ch2FFT - 채널2 FFT 데이터
     */
    addData(ch1FFT, ch2FFT) {
        const { maxHz } = this.state

        // FFT 데이터에서 0-50Hz 범위만 추출
        const ch1Data = ch1FFT.slice(0, maxHz + 1)
        const ch2Data = ch2FFT.slice(0, maxHz + 1)

        this.state.chartData.datasets[0].data = ch1Data
        this.state.chartData.datasets[1].data = ch2Data

        if (this.chartRef && this.chartRef.chartInstance) {
            this.chartRef.chartInstance.update()
        }
    }

    componentWillMount() {
        const { showLegend = true, suggestedMax } = this.props

        this.chartOption = {
            legend: {
                display: showLegend,
                position: 'top',
                labels: {
                    boxWidth: 12,
                    fontSize: 11
                }
            },
            animation: {
                duration: 0
            },
            tooltips: {
                enabled: true,
                mode: 'index',
                intersect: false,
                callbacks: {
                    title: (items) => `${items[0].label} Hz`,
                    label: (item, data) => {
                        const label = data.datasets[item.datasetIndex].label
                        return `${label}: ${parseFloat(item.value).toFixed(2)} μV`
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Frequency (Hz)',
                        fontSize: 11
                    },
                    ticks: {
                        display: true,
                        autoSkip: true,
                        maxTicksLimit: 11,
                        maxRotation: 0,
                        minRotation: 0,
                        callback: (value) => value % 5 === 0 ? value : ''
                    },
                    gridLines: {
                        display: true,
                        color: 'rgba(0,0,0,0.05)'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Amplitude (μV)',
                        fontSize: 11
                    },
                    ticks: {
                        beginAtZero: true,
                        suggestedMax: suggestedMax || 50,
                        callback: (value) => value.toFixed(0)
                    },
                    gridLines: {
                        display: true,
                        color: 'rgba(0,0,0,0.05)'
                    }
                }]
            }
        }
    }

    render() {
        const heightStyle = typeof this.state.height === 'number'
            ? this.state.height
            : this.state.height

        return (
            <div style={{ height: heightStyle, width: '100%' }}>
                <Line
                    ref={(ref) => this.chartRef = ref}
                    data={this.state.chartData}
                    options={this.chartOption}
                />
            </div>
        )
    }
}
